import { render, staticRenderFns } from "./DeployChannel.vue?vue&type=template&id=833f2db8&scoped=true"
import script from "./DeployChannel.vue?vue&type=script&lang=js"
export * from "./DeployChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833f2db8",
  null
  
)

export default component.exports